import { execute } from './execute';
import { AuthSSOArgs, AuthSSOResponse } from './interfaces/AuthService/AuthSSO';
import { User } from '../redux/admin/interfaces/AdminReducer';

// Determina el contexto basado en la URL
function determineContext(): string {
  const path = window.location.pathname;

  // Objeto de mapeo de patrones de ruta a contextos
  const contextMap: Record<string, string> = {
    'fix-tescucha': 'fix-tescucha',
    'mets-tescucha': 'mets-tescucha',
    // Agrega más patrones de ruta y contextos según sea necesario
  };

  // Buscar el contexto correspondiente al patrón de ruta
  for (const pattern in contextMap) {
    if (path.includes(pattern)) {
      return contextMap[pattern];
    }
  }

  // Si no se encuentra ningún contexto, devolver el valor predeterminado
  return 'tescucha';
}

// Crea headers dinámicos para la solicitud
function createDynamicHeaders(ssoToken: string): Record<string, string> {
  const context = determineContext();
  const domainValue = process.env.REACT_APP_DOMAIN || window.location.hostname;
  return {
    Authorization: `Bearer ${ssoToken}`,
    context,
    domain: domainValue,
  };
}

// Valida si la respuesta es del tipo User
function isValidUser(response: any): response is User {
  return (
    typeof response === 'object' &&
    response !== null &&
    typeof response.username === 'string' &&
    typeof response.token === 'string' &&
    typeof response.userData === 'object' &&
    Array.isArray(response.userData.roles)
  );
}

const AuthService = {
  authSSO: async ({ dispatch, ssoToken, ...rest }: AuthSSOArgs): Promise<AuthSSOResponse> => {
    const headers = createDynamicHeaders(ssoToken);

    try {
      const response = await execute({
        ...rest,
        dispatch,
        method: 'post',
        route: 'auth/sso',
        headers,
        showNotificationError: false,
      });

      if (isValidUser(response)) {
        console.log('Autenticación exitosa', response);
        return response; // La validación asegura el cumplimiento con AuthSSOResponse
      }
      throw new Error('La respuesta de la autenticación no tiene el formato esperado.');
    } catch (error) {
      console.error('Error en la autenticación SSO:', error);
      throw error;
    }
  },
};

export default AuthService;
